<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Analytics
        </h1>
      </div>
    </section>

    <section class="search">
      <div class="ns-container">
        <div class="row">
          <div>
            <div class="panel panel-default">
              <div class="panel-heading">
                Analytics (as of {{ analytics.info.cached_at }})
                <a
                  class="btn btn-default"
                  @click="refresh"
                >
                  <i
                    class="fas fa-sync-alt"
                    aria-hidden="true"
                  />
                </a>
              </div>

              <div class="panel-body">
                <fieldset
                  v-for="(data, key) in analytics.metrics"
                  :key="key"
                >
                  <legend>{{ key | hyphenToSentence }}</legend>
                  <TableClient :options="options(data, key)" />
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    TableClient: () => import('@/components/_vue/TableClient'),
  },

  data() {
    return {
      analytics: {
        metrics: {},
        info: {
          cached_at: null,
        },
      },
    };
  },

  created() {
    this.$store.set('general/loading', true);
    this.loadAnalytics();
  },

  methods: {
    loadAnalytics() {
      this.$http.get('/api/admin/analytics').then((response) => {
        this.$store.set('general/loading', false);
        // console.log(response.data);
        this.analytics = response.data;
      });
    },

    options(data, key) {
      // console.log(key, data);
      const columms = _.keys(data[0]);
      // console.log(columms);

      let defaultSort;

      switch (true) {
        case _.includes(columms, 'date'):
          defaultSort = 'date';
          break;
        case _.includes(columms, 'pageViews'):
          defaultSort = 'pageViews';
          break;
        case _.includes(columms, 'sessions'):
          defaultSort = 'sessions';
          break;
        default:
          defaultSort = columms[columms.length - 1];
      }

      const options = {
        name: key,
        columns: columms,
        data,
        tableOptions: {
          perPage: 10,
          orderBy: {
            column: defaultSort,
            ascending: false,
          },
        },
      };

      return options;
    },

    refresh() {
      Bus.$emit('refresh');
    },
  },
};
</script>
<style>
fieldset {
  border: 1px groove #ddd !important;
  padding: 0 1.4em 1.4em 1.4em !important;
  margin: 0 0 1.5em 0 !important;
  -webkit-box-shadow: 0 0 0 0 #000;
  box-shadow: 0 0 0 0 #000;
}

legend {
  width: inherit; /* Or auto */
  padding: 0 10px; /* To give a bit of padding on the left and right */
  border-bottom: none;
}
</style>
